<template>
  <div class="PIDSelect">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :validation="validation"
      :disabled="disabled"
      :path="path"
      :viewer="viewer"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'

import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'PIDSelect',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Application',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

      layout: [{
        'columns': '1fr 1fr',
        'fields': ['PidUuid'],
      }],
      validation: {
        PidUuid: {
          required,
        },
      },
    }
  },
  computed: {
    ...mapGetters('tenant', ['getPIDs']),
    fields() {
      return {
        'PidUuid': {
          'type': 'string',
          'title': 'PID',
          options: this.getPIDs.map(pid => {
            return {
              value: pid.uuid,
              text: pid.label,
              disabled: !pid.enabled,
            }
          }),
        },
      }
    },
  },
}
</script>
